import { createFileRoute, Outlet } from '@tanstack/react-router';

import { PersonalLayout } from '@/features/account/personal-layout';

/** An individual owner's own pages (through their personal organisation). */
export const Route = createFileRoute('/_app/account')({ component: AccountLayout });

function AccountLayout() {
  return (
    <PersonalLayout>
      <Outlet />
    </PersonalLayout>
  );
}
